import { render, staticRenderFns } from "./Administrador.vue?vue&type=template&id=2649bb5a&"
import script from "./Administrador.vue?vue&type=script&lang=js&"
export * from "./Administrador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports